import styled from 'styled-components';
import {Button, ButtonColor, ButtonSize} from '../button/button';

const StyledSwitches = styled.ul`
    &&& {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin: 17px 0 0 0;
        padding: 0;
        list-style: none;
    }
`;

const StyledSwitchButton = styled(Button).attrs(({isActive}) => ({
    color: isActive ? ButtonColor.DARK_BLUE : ButtonColor.BLUE,
}))``;

const TaskSwitches = ({tasks, activeNumber, onSwitchClick}) => {
    tasks.sort((a, b) => (a.number > b.number ? 1 : -1));
    return (
        <StyledSwitches>
            {tasks.length > 0 ? (
                tasks.map((task) => {
                    return (
                        <StyledSwitchButton
                            key={task.number}
                            isActive={task.number === activeNumber}
                            size={ButtonSize.SMALL}
                            color={ButtonColor.BLUE}
                            title={'Открыть производственное задание'}
                            onClick={() => onSwitchClick(task.number)}
                        >
                            {task.name}
                        </StyledSwitchButton>
                    );
                })
            ) : (
                <p>Производственные задания отсутствуют</p>
            )}
        </StyledSwitches>
    );
};

export {TaskSwitches};
